import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'src/app/core/interfaces';

import { AnalyticsStoreService, GenericEventService } from '../../../../../shared/services';

@Component({
  standalone: true,
  selector: 'app-store-nav-dropdown',
  templateUrl: 'store-nav-dropdown.component.html',
  imports: [RouterModule, NgOptimizedImage],
  styleUrls: ['../store-nav-dropdowns.scss', './store-nav-dropdown.component.scss'],
})
export class AppStoreNavDropdownComponent implements OnInit {
  @Input() item!: MenuItem;
  @Input({ required: true }) isVisible!: boolean;
  linksMenu: boolean = false;

  constructor(
    private genericEventService: GenericEventService,
    private analyticsStoreService: AnalyticsStoreService,
  ) {}

  ngOnInit(): void {
    this.linksMenu = this.item.dropdownStyle === 'links' ? true : false;
  }

  clickItem(): void {
    this.genericEventService.emitMenuClick(false);
  }

  gtmEvent(event: any): void {
    const category = event.currentTarget.getAttribute('data-gtmcategory');
    const action = event.currentTarget.getAttribute('data-gtmaction');
    const label = event.currentTarget.innerText;
    this.analyticsStoreService.miscEvent(category, action, label);
  }
}
